import { TnplShippingPolicy } from "@redotech/redo-tnpl-settings-common/tnpl-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const TnplContractTemplateSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string().min(1),
  description: z.string().optional(),
  trialPeriodDays: z.number().min(0).optional(),
  trialPeriodHours: z.number().min(0).optional(),
  trialPeriodMinutes: z.number().min(0).optional(),
  trialEndChargeDelayDays: z.number().min(0).optional(),
  trialEndChargeDelayHours: z.number().min(0).optional(),
  trialEndChargeDelayMinutes: z.number().min(0).optional(),
  merchantProcessingDays: z.number().min(0).optional().default(10),
  productIds: z.array(z.number()),
  sellingPlanId: z.number().nullish(),
  sellingPlanGroupId: z.number().nullish(),
  emailSubjectLine: z.string().optional(),
  cartValueLimit: z.number().min(0).optional(),
  cartMaxTnplItems: z.number().min(0).optional(),
  shippingPolicy: z
    .custom<TnplShippingPolicy>()
    .meta({ annotation: "String" })
    .optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type TnplContractTemplate = z.infer<typeof TnplContractTemplateSchema>;
export interface ITnplContractTemplate extends z.ZodType<TnplContractTemplate> {}

export type TnplContractTemplateInAutoCheck = Pick<
  TnplContractTemplate,
  | "trialPeriodDays"
  | "trialPeriodMinutes"
  | "cartValueLimit"
  | "cartMaxTnplItems"
>;
